import { IonButton, IonButtons, IonCheckbox, IonCol, IonPopover, IonContent, IonGrid, IonIcon, IonInput, IonItem, IonLabel, IonPage, IonRow, IonSelect, IonSelectOption, IonText, IonToolbar, useIonViewWillEnter, useIonViewWillLeave, useIonViewDidLeave } from '@ionic/react';
import { addOutline } from 'ionicons/icons';
import { useEffect, useRef, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useHistory } from 'react-router';
import { User } from '../../models/data';
import { translation } from '../../models/translation';
import { createFundraiser } from '../../services/fundraise_service';
import { fetchOrgList, fetchOrgsWhereAdmin } from '../../services/org_service';

interface FundraiseCreateProps {
  user: User

}

const FundraiseCreate: React.FC<FundraiseCreateProps> = ({ user }) => {

  const siteText = translation()

  const lan = siteText.lan.replace("/", "")

  const history = useHistory()

  const [init, setInit] = useState<boolean>(false)

  const [orgList, setOrgList] = useState<any[]>()

  const getFormatedDate = (dateString: any) => {
    let fullDate = new Date(dateString)
    let year = fullDate.getFullYear()

    let month = `${fullDate.getMonth() + 1}`
    let day = `${fullDate.getDate()}`

    if (month.length < 2) { month = 0 + month }
    if (day.length < 2) { day = 0 + day }

    let formatedDate = `${year}-${month}-${day}`

    return formatedDate;

  }

  const tomorrow = new Date();

  tomorrow.setDate(new Date().getDate());

  const minDate = getFormatedDate(tomorrow);


  useIonViewWillEnter(() => {
    if (!init) {
      getOrgList();
      fetchOrgsWhereAdmin(user.id).then(m => setCreatorOrgs(m.message))
      setInit(true)
    }
  })

  useIonViewWillLeave(() => {
    setTitle(null);
    setStartDate(null);
    setEndDate(null);
    setReason(null);
    setDescription(null);
    setTarget(null);
    setDestination(null)
    setDestinationOrg(null);
    setAnonymous(undefined)
    setCreatorOrg(undefined)
    setCreatorOrgs(undefined)
    setInit(false)

  })

  const getOrgList = async () => {
    let orgs = await fetchOrgList();
    setOrgList(orgs.message);
  }


  const updateOrg = (value: any) => {
    if (value === "account") {
      setDestination('self')
      setDestinationOrg(null)
    } else {
      setDestination('organisation')
      setDestinationOrg(value)
    }
  }

  const [title, setTitle] = useState<string | null>();
  const [start_date, setStartDate] = useState<string | null>();
  const [end_date, setEndDate] = useState<string | null>();
  const [reason, setReason] = useState<string | null>();
  const [image, setImage] = useState<File | null>();
  const [description, setDescription] = useState<any>();
  const [target, setTarget] = useState<string | null>();
  const [destination, setDestination] = useState<string | null>();
  const [destination_org, setDestinationOrg] = useState<string | null>();
  const [createrOrgs, setCreatorOrgs] = useState<[any]>();
  const [createrOrg, setCreatorOrg] = useState<any>();
  const [disabled, setDisabled] = useState<boolean>(false);
  const [anonymous, setAnonymous] = useState<boolean>()

  const popover = useRef<HTMLIonPopoverElement>(null);
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [isProcesseng, setIsProcessing] = useState<string>()


  useIonViewDidLeave(()=>{
    setTitle(null) 
    setStartDate(null)
    setEndDate(null)
    setReason(null)
    setImage(null)
    setDescription(null)
    setTarget(null)
    setDestination(null)
    setDestinationOrg(null)
    setCreatorOrg(null)
    setAnonymous(false)
  })

  const completeDonation = () => {
    setPopoverOpen(false)
    setTimeout(() => {
      history.push(`/${lan}/account/fundraise`)
    }, 30)
  }

  const [validatition, setValidation] = useState({
    image: false,
    title: false,
    reason: false,
    start_date: false,
    end_date: false,
    target: false,
    destination: false,
    description: false,
  })

  const validateForm = () => {
    if (!image) {
      setValidation({ ...validatition, image: true })
      setDisabled(false)
      return false
    }

    let validationState = validatition;
    let validationResult = true;

    if (!title) {
      validationState.title = true;
      validationResult = false;

    }

    if (!start_date) {
      validationState.start_date = true;
      validationResult = false;

    }

    if (!end_date) {
      validationState.end_date = true;
      validationResult = false;

    }

    if (!description) {
      validationState.description = true;
    }

    if (!target) {
      validationState.target = true;
      validationResult = false;

    }

    if (!destination) {
      validationState.destination = true;
      validationResult = false;

    }
    if (!reason) {
      validationState.reason = true;
      validationResult = false;

    }
    setValidation(validationState)
    return validationResult;

  }

  useEffect(() => {
    if (!description) {
      setValidation({ ...validatition, description: false })
    }
  }, [])

  const onSubmit = (e: any) => {
    e.preventDefault();
    let anonymousValue = 1;
    if (!anonymous) { anonymousValue = 0 }
    setDisabled(true);

    let data = {
      title: title,
      file: image,
      status: 'publish',
      acf: {
        start_date: start_date,
        end_date: end_date,
        reason: reason,
        image: null,
        description: description,
        target: target,
        destination: destination,
        destination_org: destination_org,
        anonymous: anonymousValue,
        status: 0,
        author_org: createrOrg=='none'?null:createrOrg

      }
    }
    if (!validateForm()) {
      setDisabled(false)
      return
    }
    setIsProcessing('processing')
    setPopoverOpen(true)

    createFundraiser(data).then(
      m => {
        if (m?.message) {
          e.target.reset()
          setIsProcessing('done');
          setDisabled(false);
        } else {
          console.log(m)
          setIsProcessing('error')
          setDisabled(false);
          return
        }
      }
    )
  }

  const ChosenDateStatus = () => {
    if (!end_date || !start_date) return (<></>);
    if (end_date < start_date) {
      return (<p className='ion-padding-bottom'>
        {siteText.fundraiseCreateEndStartDateWarning}
      </p>)
    } else {
      return (<></>)
    }
  }
  return (
    <IonPage >
      <IonContent>
        <IonGrid className='innerBody sw_sp_md' >
          <IonRow>
            <IonCol className="pageConent ion-text-uppercase" offsetSm='1' sizeSm='8'>
              <h1>{siteText.fundraiseTitle}</h1>
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol offset='1' size='10'>
              <IonToolbar mode='md' >
                <IonButtons className='fundraiserTabs'>
                  <IonButton routerLink={siteText.lan + '/account/fundraise'}>{siteText.fundraiseAllSectTitle}</IonButton>
                  <IonButton routerLink={siteText.lan + '/account/fundraisersbyuser'}>{siteText.fundraiseUserSectTitle}</IonButton>
                  <IonButton className='active' color='primary' fill='clear'>{siteText.fundraiseCreateTitle}<IonIcon icon={addOutline} /></IonButton>
                </IonButtons>
              </IonToolbar>
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol offsetSm="1" sizeSm='8'>
              <form onSubmit={onSubmit}>
                <IonRow>
                  <IonCol sizeXs='12'>
                    <IonLabel position="stacked" >{siteText.fundraiseCreateTitleLabel}</IonLabel>
                    <IonInput className="ion-margin-bottom ion-margin-top" placeholder={siteText.fundraiseCreateTitleHolder} min="0" type="text" onIonChange={e => { setValidation({ ...validatition, title: false }); setTitle(e.detail.value) }}></IonInput>

                    {validatition.title ?
                      <IonText color='danger'>
                        <p style={{ marginTop: 0 }}>{siteText.fundraiseCreateTitleWarning}</p>
                      </IonText>
                      : ''}

                    <IonLabel position="stacked">{siteText.fundraiseCreateReasonLabel}
                    </IonLabel>
                    <IonInput className="ion-margin-bottom ion-margin-top" placeholder={siteText.fundraiseCreateReasonHolder} onIonChange={e => { setValidation({ ...validatition, reason: false }); setReason(e.detail.value) }} ></IonInput>

                    {validatition.reason ?
                      <IonText color='danger'>
                        <p style={{ marginTop: 0 }}>{siteText.fundraiserCreateReasonWarning}</p>
                      </IonText>
                      : ''}

                    <IonLabel position="stacked">{siteText.fundraiseCreateDestinationLabel}</IonLabel>
                    <IonSelect className="ion-margin-bottom ion-margin-top" interface="popover" okText="Okay" placeholder={siteText.fundraiseCreateDestinationPlaceholder} cancelText="Dismiss" onIonChange={e => { setValidation({ ...validatition, destination: false }); updateOrg(e.detail.value) }}>
                      <IonSelectOption value="account">{siteText.fundraiseDetailDestinationSw}</IonSelectOption>
                      {orgList?.map((m: any, key) => {
                        return <IonSelectOption key={key} value={m.id} dangerouslySetInnerHTML={{__html:m.title.rendered}}></IonSelectOption>
                      })}
                    </IonSelect>

                    {validatition.destination ?
                      <IonText color='danger'>
                        <p style={{ marginTop: 0 }}>{siteText.fundraiseCreateBeneficiaryWarning}</p>
                      </IonText>
                      : ''}
                    <IonLabel position="stacked">{siteText.fundraiseCreatePublishAsOrgLabel}</IonLabel>
                    <IonSelect value={createrOrg} onIonChange={e => setCreatorOrg(e.detail.value)} style={{ width: '100%' }} disabled={!createrOrgs || createrOrgs.length < 1} placeholder="Pick an organisation">
                      <IonSelectOption value={'none'}>None</IonSelectOption>
                      {createrOrgs && createrOrgs.map((orgPage, key) => <IonSelectOption key={key} value={orgPage.id} dangerouslySetInnerHTML={{ __html: orgPage.title }}></IonSelectOption>)}
                    </IonSelect>
                    <p>{siteText.fundraiseCreatePublishAsOrgNotice}</p>
                  </IonCol>
                  <IonCol sizeXs='12'>
                    <div className="ion-margin-top ion-margin-bottom">
                      <IonLabel position="stacked">{siteText.fundraiseCreateStartLabel}</IonLabel>
                      { /*<IonDatetime className="ion-margin-top" showDefaultButtons={false} showClearButton={true} presentation="date" mode="ios" ></IonDatetime>*/}
                      <IonInput type='date' pattern="\d{4}-\d{2}-\d{2}" className='ion-margin-top' min={minDate} onIonChange={e => { setValidation({ ...validatition, start_date: false }); setStartDate(e.detail.value) }} ></IonInput>
                    </div>

                    {validatition.start_date ?
                      <IonText color='danger'>
                        <p style={{ marginTop: 0 }}>{siteText.fundraiseCreateStartDateWarning}</p>
                      </IonText>
                      : ''}

                  </IonCol>
                  <IonCol sizeXs='12'>
                    <div className="ion-margin-top ion-margin-bottom">
                      <IonLabel position="stacked">{siteText.fundraiseCreateEndLabel}</IonLabel>
                      {/*<IonDatetime className="ion-margin-top" showDefaultButtons={false} showClearButton={true} presentation="date" mode="ios" onIonChange={e => { setValidation({ ...validatition, end_date: false }); setEndDate(e.detail.value) }}></IonDatetime>*/}
                      <IonInput className='ion-margin-top' type='date' pattern="\d{4}-\d{2}-\d{2}" onIonChange={e => { setValidation({ ...validatition, end_date: false }); setEndDate(e.detail.value) }}></IonInput>
                    </div>

                    {validatition.end_date ?
                      <IonText color='danger'>
                        <p style={{ marginTop: 0 }}>{siteText.fundraiseCreateEndDateWarning}</p>
                      </IonText>
                      : ''}

                  </IonCol>
                  <IonCol sizeSm='12'>
                    <IonText color='danger'>
                      <ChosenDateStatus />
                    </IonText>
                  </IonCol>
                  <IonCol sizeXs='12'>
                    <IonLabel position="stacked">{siteText.fundraiseCreateAmountLabel}</IonLabel>
                    <IonItem lines='none' className="cashField ion-margin-top ion-margin-bottom">
                      <IonInput placeholder={siteText.fundraiseCreateAmountPlaceholder} min="0" type="number" onIonChange={e => { setValidation({ ...validatition, target: false }); setTarget(e.detail.value) }}></IonInput>
                      <IonText className='ion-padding-start'>CHF</IonText>
                    </IonItem>

                    {validatition.target ?
                      <IonText color='danger'>
                        <p style={{ marginTop: 0 }}>{siteText.fundraiseCreateTargetWarning}</p>
                      </IonText>
                      : ''}

                    <IonLabel>{siteText.fundraiseCreateDescriptionLabel}</IonLabel>
                    <ReactQuill className='ion-margin-top' placeholder={siteText.fundraiseCreateDescriptionPlaceholder} onChange={setDescription} value={description}></ReactQuill>

                    {validatition.description ?
                      <IonText color='danger'>
                        <p className='ion-margin-bottom' style={{ marginTop: 0 }}>{siteText.fundraiseCreateDescriptionWarning}</p>
                      </IonText>
                      : ''}


                    <IonLabel className='ion-margin-top'>{siteText.fundraiseCreatePictureSelection} | jpeg - png</IonLabel>
                    <input className="ion-margin-top" placeholder="cover image" type="file" onChange={e => { setValidation({ ...validatition, image: false }); setImage(e.target.files![0]) }}></input>
                     <IonText color='medium'>
                      <p>{siteText.imageRatioRecommendation}</p>
                     </IonText>

                    {validatition.image ?
                      <IonText color='danger'>
                        <p style={{ marginTop: 0 }}>{siteText.fundraiseCreateImageWarning}</p>
                      </IonText>
                      : ''}

                    <IonItem lines='none' className='ion-margin-top ion-margin-bottom'>
                      <IonCheckbox checked={anonymous} onIonChange={(e) => setAnonymous(e.detail.checked)}></IonCheckbox>
                      <IonLabel className='ion-margin-start'>{siteText.fundraiseCreateLabel}</IonLabel>
                    </IonItem>

                    <IonButton strong disabled={disabled}  className="ion-margin-top" type="submit">
                      <IonText color='light'>
                        {siteText.fundraiseCreatePrimary}
                      </IonText>
                    </IonButton>
                  </IonCol>
                </IonRow>

              </form>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
      <IonPopover ref={popover} isOpen={popoverOpen} backdropDismiss={false}>
        <IonContent>
          <IonGrid>
            <IonRow className="ion-padding">
              {isProcesseng === 'processing' &&
                <IonCol size="12">{siteText.fundraiseCreateEditAlertProcessing}</IonCol>}
              {isProcesseng === 'done' && <IonCol size="12">
                <p>{siteText.fundraiseCreateSuccess}
                </p>
                <IonButton color="success" onClick={completeDonation}> <IonText color="light">{siteText.donateUseCreditDetailsDoneString}</IonText> </IonButton>
              </IonCol>}
              {isProcesseng === 'error' && <IonCol size="12">
                <p>{siteText.fundraiseCreateEditError}
                </p>
                <IonButton color="secondary" onClick={e => setPopoverOpen(false)}><IonText color="light">{siteText.donateUseCreditDetailsTryAgainString}</IonText> </IonButton>
              </IonCol>}
            </IonRow>
          </IonGrid>
        </IonContent>
      </IonPopover>
    </IonPage>

  )

}

export default FundraiseCreate;
